/* tslint:disable */
/* eslint-disable */
/**
 * PanKanapka
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    VoucherCategory,
    VoucherCategoryFromJSON,
    VoucherCategoryFromJSONTyped,
    VoucherCategoryToJSON,
} from './';

/**
 * 
 * @export
 * @interface VoucherCategoryDataFrame
 */
export interface VoucherCategoryDataFrame {
    /**
     * 
     * @type {number}
     * @memberof VoucherCategoryDataFrame
     */
    count: number;
    /**
     * 
     * @type {number}
     * @memberof VoucherCategoryDataFrame
     */
    offset: number;
    /**
     * 
     * @type {number}
     * @memberof VoucherCategoryDataFrame
     */
    limit: number;
    /**
     * 
     * @type {Array<VoucherCategory>}
     * @memberof VoucherCategoryDataFrame
     */
    data: Array<VoucherCategory>;
}

export function VoucherCategoryDataFrameFromJSON(json: any): VoucherCategoryDataFrame {
    return VoucherCategoryDataFrameFromJSONTyped(json, false);
}

export function VoucherCategoryDataFrameFromJSONTyped(json: any, ignoreDiscriminator: boolean): VoucherCategoryDataFrame {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'count': json['count'],
        'offset': json['offset'],
        'limit': json['limit'],
        'data': ((json['data'] as Array<any>).map(VoucherCategoryFromJSON)),
    };
}

export function VoucherCategoryDataFrameToJSON(value?: VoucherCategoryDataFrame | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'count': value.count,
        'offset': value.offset,
        'limit': value.limit,
        'data': ((value.data as Array<any>).map(VoucherCategoryToJSON)),
    };
}


